
import router from '@/router/index'
import packageService from '@/api/packageConfigService'
import {notify, notifyWarn } from "@/utils/notification-helper"
// import Vue from "vue";



const state = {

    module: [],
    packs: [],
    newPackage: {},
    edit: false,
    products: []
}
const getters = {
    packModule: state => state.module,
    PackageData: state => state.packs,
    newPackage: state => state.newPackage,
    edit: state => state.edit,

};

const actions = {

    async addPackage({ commit }, pack) {
        const resp = await packageService.addPackage(pack)
        if(resp.data?.status === true){
            notify("Package added successfully")
        }
        else{
            notifyWarn("Unable to add package.")
        }

        commit('add', pack)
    },
    async editPackage({ commit }, pack) {
        await packageService.getPackageById(pack.id)
        commit('edit', pack)
    },
    async updatePackage({ commit, rootState }, pack) {
        var t = pack.Modules;
        var value = [];
        t.map(item => {
            value.push({ id: item.ID });
        });

        let data = {
            modules: value,
            productID: pack.productID,
            id: pack.id,
            name: pack.Name
        }
        const resp = await packageService.updatePackage(pack.id, pack)
        if(resp.data?.status === true){
            notify("Package updated successfully")
        }
        else{
            notifyWarn("Unable to update package.")
        }
        const index = rootState.packageData.map(item => item.id).indexOf(pack.id)
        rootState.packageData[index] = data;
        commit('update', pack)
    },
    async removePackage({ commit, rootState }, pack) {
        const resp = await packageService.removePackage(pack.dataItem.id)
        if(resp.data?.status === true){
            notify("Package deleted successfully")
        }
        else{
            notifyWarn("Unable to delete package.")
        }
        var packageData = rootState.packageData
        const index = packageData.map(item => item.id).indexOf(pack.dataItem.id)
        packageData.splice(index, 1)
        commit('remove', pack)
    },
    async getModule({ commit }, ) {
        const response = await packageService.getModule();
        commit('getModuleValue', response.data.result)

    }
}
const mutations = {

    getModuleValue(state, pack) {

        state.module = pack
    },
    add(state, pack) {
        state.packs.push(pack);
        state.newPackage = { modules: {} }
    },
    edit(state, pack) {
        state.editId = pack.id
        state.edit = true
        let modules = state.module
        state.module = modules
        state.newPackage = pack
        router.push({ name: "addPackage", params: { add: false } });
    },
    update(state) {

        state.newPackage = { modules: {} }

    },
    remove(state, pack) {
        var packs = state.packs
        const index = packs.map(item => item.id).indexOf(pack.id)
        packs.splice(index, 1)
    },
    cancel(state) {
        state.newPackage = { modules: {} }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}